import "./styles/OnBoardingButton.css";

export default function OnBoardingButton({
  children,
  className = '',
  isActive = false,
  onClick,
  fullWidth = false,
  ...buttonProps
}) {
  const getClasses = () => {
    let classes = "";
    if(isActive) {
      classes = " active";
    }
    if(fullWidth) {
      classes += " w-full";
    }
    return classes;
  };

  return (        
    <>
      <button
        type="button"
        className={`onboarding__button ${className} ${getClasses()}`}
        onClick={onClick}
        {...buttonProps}
      >        {children}
      </button>
    </>
  );
}